import { render, staticRenderFns } from "./CategoryUpdateDialogCarouselDescription.vue?vue&type=template&id=f1c6b17c&scoped=true"
import script from "./CategoryUpdateDialogCarouselDescription.vue?vue&type=script&lang=ts"
export * from "./CategoryUpdateDialogCarouselDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c6b17c",
  null
  
)

export default component.exports